import { Pipe, PipeTransform } from '@angular/core';
import { ContractStatus } from '@app/features/contracts/contract.model';

function assertNever(x: never): never {
  throw new Error(`Unexpected status: ${x}`);
}

@Pipe({
  name: 'contractStatusLabel',
})
export class ContractStatusLabelPipe implements PipeTransform {
  transform(status: ContractStatus | null | undefined): string {
    if (!status) {
      return 'N/A';
    }
    switch (status) {
      case 'DRAFT':
        return 'Brouillon';
      case 'REX_VALIDATING':
        return 'Validation au REX';
      case 'REX_VALIDATED':
        return 'Validé par le REX';
      case 'DA_VALIDATING':
        return 'Validation au Directeur Agence';
      case 'DA_VALIDATED':
        return 'Validé par le Directeur Agence';
      case 'DP_VALIDATING':
        return 'Validation au Directeur Production';
      case 'DP_VALIDATED':
        return 'Validé par le Directeur Production';
      case 'RRH_VALIDATING':
        return 'Validation au Responsable RH';
      case 'RRH_VALIDATED':
        return 'Validé par le Responsable RH';
      case 'DRH_VALIDATING':
        return 'Validation au DRH';
      case 'SIGNING':
        return 'Signature';
      case 'SIGNED':
        return 'Signé';
      case 'CANCELED':
        return 'Annulé';
      default: {
        return assertNever(status as never);
      }
    }
  }
}
